/* **The pill's GEOMETRY** — the rounded control the Pulpit („Otwórz", „Zaproś klienta") and `/konto`
 * (every primary, secondary and destructive act) both draw. Promoted 4 November 2026 on its second
 * consumer: the two stylesheets carried the same eight declarations and differed only in height and
 * type size.
 *
 * A stylesheet with no component, worn BESIDE a treatment (`emberButton`'s `.ember.pill`, or
 * `ghostButton`'s `.ghost` with a modifier) and beside the surface's own class, which declares the
 * two values that differ: `height` and `font-size` (and `line-height` where the canon sets one).
 * Nothing here is declared by `ghostButton`. `justify-content` and `white-space` are also declared by
 * `emberButton` with the SAME values, so the order the two chunks land in cannot change the outcome;
 * they are here because a ghost declares neither and a full-width pill must still centre one line. */

.pill {
  gap: var(--space-6px);
  justify-content: center;
  padding: var(--space-0) var(--space-14px);
  font-weight: var(--fw-semibold);
  letter-spacing: normal;
  white-space: nowrap;
  text-decoration: none;
  border-radius: var(--r-pill);
}
